import axios from "axios";
import config from "../../../config";

/**
 * POST api/v1/customer-portal/categories
 * Returns online-bookable categories for the logged-in client's salon.
 * Hidden-from-online categories are omitted unless editAppointmentId is passed
 * (those already on that booking stay available for edit/reschedule).
 */
export function fetchCustomerPortalCategories(token, editAppointmentId) {
  const body = {};
  if (editAppointmentId) {
    body.edit_appointment_id = Number(editAppointmentId);
  }
  return axios.post(`${config.API_URL}customer-portal/categories`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/category-services
 * Body: { category_id: number, edit_appointment_id?: number }
 * Active bookable services + active staff (online booking), with tier-based price.
 * Hidden-from-online services/categories are omitted unless they are already on the edited booking.
 */
export function fetchCustomerPortalCategoryServices(token, categoryId, editAppointmentId) {
  const body = { category_id: categoryId };
  if (editAppointmentId) {
    body.edit_appointment_id = Number(editAppointmentId);
  }
  return axios.post(
    `${config.API_URL}customer-portal/category-services`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

/**
 * POST api/v1/customer-portal/availability/month
 * Body: { year_month, segments: [{ staff_id, duration_minutes }], padding_minutes?, exclude_appointment_id? }
 */
export function fetchCustomerPortalAvailabilityMonth(token, body) {
  return axios.post(`${config.API_URL}customer-portal/availability/month`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/availability/day-slots
 * Body: { date: YYYY-MM-DD, segments, padding_minutes?, exclude_appointment_id? }
 */
function asList(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
}

function normalizeDaySlotsResponse(res) {
  const raw = res?.data;
  const payload =
    raw && typeof raw === "object" && (raw.day_slots || raw.waitlist_slots || raw.slots)
      ? raw
      : raw?.data && typeof raw.data === "object"
        ? raw.data
        : raw || {};
  return {
    ...res,
    data: {
      timezone: payload.timezone,
      slot_minutes: payload.slot_minutes,
      slots: asList(payload.slots),
      waitlist_slots: asList(payload.waitlist_slots),
      day_slots: asList(payload.day_slots),
    },
  };
}

export function fetchCustomerPortalAvailabilityDaySlots(token, body) {
  return axios
    .post(`${config.API_URL}customer-portal/availability/day-slots`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then(normalizeDaySlotsResponse);
}

/**
 * POST api/v1/customer-portal/availability/validate-start-time
 * Body: { start_datetime, segments, padding_minutes?, exclude_appointment_id? }
 */
export function validateCustomerPortalStartTime(token, body) {
  return axios.post(`${config.API_URL}customer-portal/availability/validate-start-time`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}
